import type { Pagination } from '~/interfaces/pagination';
import type { Product } from '~/interfaces/product';

export const productsKeys = {
  all: ['products'] as const,
  list: (blockId?: string) => ['products', 'list', blockId] as const,
  page: (blockId: string | undefined, page: number, perPage: number, productTagIds?: string[]) =>
    ['products', 'list', blockId, page, perPage, productTagIds] as const,
};

export interface ProductsLoaderData {
  products: Product[];
  pagination: Pagination;
}

export const fetchProducts = async (
  page: number,
  perPage: number,
  productTagIds?: string[],
): Promise<ProductsLoaderData> => {
  const params = new URLSearchParams();
  params.set('page', String(page));
  params.set('per_page', String(perPage));
  if (productTagIds?.length) {
    for (const tagId of productTagIds) {
      params.append('product_tag_ids[]', tagId);
    }
  }
  const response = await fetch(`/products_list?${params.toString()}`);
  if (!response.ok) throw new Error('Failed to fetch products');
  return response.json();
};
